export default __webpack_public_path__ + "static/media/drug1.fdbb94a1.png";